module.exports = __webpack_public_path__ + "static/media/green.caa2e622.jpg";